import React, { lazy, Suspense } from 'react';
import { Loaders } from 'components';

const LazyAuthLayout = lazy(() => import('features/auth/containers/Layout'));

export const AuthLayout = () => (
  <Suspense fallback={<Loaders.Standard />}>
    <LazyAuthLayout />
  </Suspense>
);
